import React from "react";
import 'react-toastify/dist/ReactToastify.css';
import GoogleLogin from "react-google-login";
import {connect} from "react-redux";
import * as PropTypes from "prop-types";
import {history} from "../../redux/store/configureStore";
import LoginForm from "./LoginForm";
import {GOOGLE_CLIENT_ID, STATUS} from "../common/Const";
import {email, mandatory, validateValues} from "../common/Validations";
import * as userActions from "../../redux/actions/usersActions";
import {hasNoErrors} from "../common/Helpers";

const validationConfig = {
  username: {
    label: "Email",
    validate: [mandatory, email],
  },
  password: {
    label: "HasÅ‚o",
    validate: [mandatory],
  },
};

const handleCancel = () => {
  history.goBack();
};

export class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      credentials: { username: '', password: '' },
      errors: {},
      touched: {},
      status: STATUS.IDLE,
    };
    this.isCancelled = false;
  }

  componentWillUnmount() {
    this.isCancelled = true;
  }

  handleBlur = (event) => {
    const { name } = event.target;
    const { touched } = this.state;
    this.setState({ touched: { ...touched, [name]: true } });
    this.validate();
  };

  handleChange = (event) => {
    const { credentials } = this.state;
    const { name, value } = event.target;
    credentials[name] = value;
    this.setState({ credentials });
    this.validate();
  };

  handleSubmit = (event) => {
    if (event) event.preventDefault();
    this.setState({ status: STATUS.SUBMITTING });
    const { credentials } = this.state;
    const { signIn } = this.props;
    const isValid = this.validate();
    if (isValid) {
      signIn({ id: credentials.username, password: credentials.password })
        .then(() => {
          if (!this.isCancelled) {
            this.setState({ status: STATUS.COMPLETED, errors: {} });
          }
        })
        .catch((error) => {
          if (!this.isCancelled) {
            this.setState({ errors: { saveError: error.message }, status: STATUS.SUBMITTED });
          }
        });
    } else {
      this.setState({ status: STATUS.SUBMITTED });
    }
  };

  handleGoogleSuccess = (response) => {
    const { signInWithGoogle } = this.props;

    if (!response || !response.tokenId) {
      this.handleGoogleFailure();
      return Promise.resolve();
    }

    this.setState({ status: STATUS.SUBMITTING });

    return signInWithGoogle(response.tokenId)
      .then(() => {
        if (!this.isCancelled) {
          this.setState({ status: STATUS.COMPLETED, errors: {} });
        }
      })
      .catch((error) => {
        if (!this.isCancelled) {
          this.setState({
            errors: { saveError: error.message },
            status: STATUS.SUBMITTED,
          });
        }
      });
  };

  handleGoogleFailure = () => {
    if (!this.isCancelled) {
      this.setState({
        errors: { saveError: "Nie udało się zalogować przez Google. Spróbuj ponownie." },
        status: STATUS.SUBMITTED,
      });
    }
  };

  validate() {
    const { credentials } = this.state;
    const errors = validateValues(credentials, validationConfig);
    this.setState({ errors });
    return hasNoErrors(errors);
  }

  render() {
    const { credentials, touched, errors, status } = this.state;
    const disabled = status === STATUS.SUBMITTING;

    return (
      <div>
        { Object.keys(errors).length > 0 && status === STATUS.SUBMITTED && (
          <div role="alert" className="alert alert-danger">
            <p>BÅ‚Ä™dy na stronie:</p>
            <ul>
              {Object.keys(errors).map(key => <li key={key}>{errors[key]}</li>)}
            </ul>
          </div>
        )}
        <LoginForm
          username={credentials.username}
          password={credentials.password}
          touched={touched}
          errors={errors}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
          onCancel={handleCancel}
          status={status}
          disabled={disabled}
          ssoButton={(
            <GoogleLogin
              clientId={GOOGLE_CLIENT_ID}
              onSuccess={this.handleGoogleSuccess}
              onFailure={this.handleGoogleFailure}
              cookiePolicy="single_host_origin"
              render={renderProps => (
                <button
                  type="button"
                  className="btn manage-button manage-teal-button btn-block"
                  onClick={renderProps.onClick}
                  disabled={disabled || renderProps.disabled}
                >
                  Sign in with SSO
                </button>
              )}
            />
          )}
        />
      </div>
    );
  }
}

Login.propTypes = {
  signIn: PropTypes.func.isRequired,
  signInWithGoogle: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  signIn: userActions.signIn,
  signInWithGoogle: userActions.signInWithGoogle,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
